<template>
    <div class="form">

        <PositionApplyingForm
            ref="positionsForm"
            @data-changed="updateForm"
            :positions="positions"
            :licenses-list="licenses"
            :user="user"
            :view-rates="true"
        >
        </PositionApplyingForm>

        <div class="row">
            <div class="col-12 text-right ">
                <div class="wrap-border-top">
                    <div class="btns-wrap">
                        <a href="/application-step-2"
                           class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                        <a href="javascript:void(0)"
                           class="btn btn--secondary w-100 w-sm-auto" @click="validate">Continue</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import PositionApplyingForm from "../CommonForms/PositionApplyingForm";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    components: {
        PositionApplyingForm
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        positions: {
            type: Array
        },
        licenses: {
            type: Array
        },
    },
    name: "ApplicantFormStep3",
    data() {
        return {
            dataFormStep3: {}
        }
    },

    methods: {
        async validate() {
            const valid = await this.$refs.positionsForm.$refs.formValid.validate();
            if (!valid) {
                this.$showErrorMessage('Your answer is not valid. Please check all required fields.')
                return;
            }
            if (this.dataFormStep3.licenses.length > 0) {
                await this.save();
            } else {
                this.$showErrorMessage('The license field id required')
            }
        },
        async save() {
            try {
                const response = await ApplicationFormService.saveStep3(this.dataFormStep3);
                if (response.status === 200) {
                    this.$showSuccessMessage();
                    setTimeout(() => {
                        window.location.href = '/application-step-4';
                    }, 1000)
                }
            } catch (error) {
                this.$handleErrors(error)
            }
        },
        updateForm(dataPositionApplyingForm) {
            this.dataFormStep3 = dataPositionApplyingForm
        }
    },
}
</script>

<style scoped>

</style>
